var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 5 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.62,32.81c-1.64,0-3.23-.32-4.73-.96-1.45-.61-2.75-1.49-3.86-2.61-1.12-1.12-1.99-2.42-2.61-3.86-.63-1.5-.96-3.09-.96-4.73s.32-3.23.96-4.73c.61-1.45,1.49-2.75,2.61-3.86,1.12-1.12,2.42-1.99,3.86-2.61,1.5-.63,3.09-.96,4.73-.96s3.23.32,4.73.96c1.45.61,2.75,1.49,3.86,2.61,1.12,1.12,1.99,2.42,2.61,3.86.63,1.5.96,3.09.96,4.73s-.32,3.23-.96,4.73c-.61,1.45-1.49,2.75-2.61,3.86-1.12,1.12-2.42,1.99-3.86,2.61-1.5.63-3.09.96-4.73.96ZM20.62,10.16c-1.42,0-2.79.28-4.08.82-1.25.53-2.37,1.28-3.33,2.25-.96.96-1.72,2.09-2.25,3.33-.55,1.29-.82,2.67-.82,4.08s.28,2.79.82,4.08c.53,1.25,1.28,2.37,2.25,3.33s2.09,1.72,3.33,2.25c1.29.55,2.67.82,4.08.82s2.79-.28,4.08-.82c1.25-.53,2.37-1.28,3.33-2.25.96-.96,1.72-2.09,2.25-3.33.55-1.29.82-2.67.82-4.08s-.28-2.79-.82-4.08c-.53-1.25-1.28-2.37-2.25-3.33-.96-.96-2.09-1.72-3.33-2.25-1.29-.55-2.67-.82-4.08-.82Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "19.78 23.96 19.44 13.98 21.78 13.98 21.45 23.96 19.78 23.96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.63,
    y: 25.36,
    width: 1.97,
    height: 1.97
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadIcon);
export default __webpack_public_path__ + "static/media/bad-icon.beecbea4b9a20fd94ca327bb3a98dd1f.svg";
export { ForwardRef as ReactComponent };